import { Table } from 'antd';
import React from 'react';


const columns = [
  {
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
    ellipsis: true,
    fixed: 'left',
    width: '200px',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'On Hand Quantity',
    dataIndex: 'on_hand_quantity',
    key: 'on_hand_quantity',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Reserved Quantity',
    dataIndex: 'reserved_quantity',
    key: 'reserved_quantity',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Counted Quantity',
    dataIndex: 'counted_quantity',
    key: 'counted_quantity',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Difference',
    dataIndex: 'difference',
    key: 'difference',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Stock Value (GHc)',
    dataIndex: 'value',
    key: 'value',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
]



const data = [
  {
    location: 'TSTWH/Stock', children: [
      {product: 'Cements', on_hand_quantity: 12, reserved_quantity: 32, counted_quantity: 42, difference: 5, value: 100},
      {product: 'Cements', on_hand_quantity: 12, reserved_quantity: 32, counted_quantity: 42, difference: 5, value: 100},
      {product: 'Cements', on_hand_quantity: 12, reserved_quantity: 32, counted_quantity: 42, difference: 5, value: 100},
      {product: 'Cements', on_hand_quantity: 12, reserved_quantity: 32, counted_quantity: 42, difference: 5, value: 100},
      {product: 'Cements', on_hand_quantity: 12, reserved_quantity: 32, counted_quantity: 42, difference: 5, value: 100},
      {product: 'Cements', on_hand_quantity: 12, reserved_quantity: 32, counted_quantity: 42, difference: 5, value: 100},
      {product: 'Cements', on_hand_quantity: 12, reserved_quantity: 32, counted_quantity: 42, difference: 5, value: 100},
      {product: 'Cements', on_hand_quantity: 12, reserved_quantity: 32, counted_quantity: 42, difference: 5, value: 100},
    ]
  }
]


const TestStockSheets = () => {
  return (
    <div style={{backgroundColor: 'white'}}>
      <table>
        <thead>
          <tr>
            <th>Location</th>
            <th>Product</th>
            <th>Reserved Quantity</th>
            <th>On Hand Quantity</th>
            <th>Counted Quantity</th>
            <th>Difference</th>
            <th>Stock Value</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, id) => 
            <>
              <tr key={id}>
                <td>{item.location}</td>
                
              </tr>
              {item.children.map((obj, idx) => 
                  <tr key={idx}>
                    <td>{''}</td>
                    <td>{obj.product}</td>
                    <td>{obj.on_hand_quantity}</td>
                    <td>{obj.reserved_quantity}</td>
                    <td>{obj.counted_quantity}</td>
                    <td>{obj.difference}</td>
                    <td>{obj.value}</td>
                  </tr>
                )}
            </>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default TestStockSheets;